export default function Vector() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        id="Vector 23"
        d="M4.64748 16C4.64748 16 0.896883 9.02564 0 8.36923C0.733813 7.63077 2.55 6.91529 3.42446 7.38462C4.29892 7.85395 5.95 10.5263 5.95 10.5263C5.95 10.5263 9.1345 4.21648 15.1806 0.872538C15.5639 0.660554 15.9009 1.13732 15.6097 1.46448C10.4258 7.28796 8.48465 13.7385 7.58273 14.6462C6.60432 15.6308 4.64748 16 4.64748 16Z"
        fill="white"
      />
    </svg>
  );
}
